<!--
 * @Description: 人员报备统计
 * @Author: 琢磨先生
 * @Date: 2023-02-18 21:33:47
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-02-10 16:02:36
-->
<template>
  <el-card class="box query">
    <el-form :model="query" ref="query" :inline="true">
      <el-form-item label="日期">
        <el-date-picker
          v-model="query.dates"
          type="daterange"
          value-format="YYYY-MM-DD"
          unlink-panels
          :clearable="false"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="公司分类">
        <el-select
          v-model="query.isDeyou"
          placeholder
          clearable
          style="width: 150px"
        >
          <el-option label="德佑" :value="true"></el-option>
          <el-option label="分销" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="人员">
        <el-input
          v-model="query.q"
          placeholder="姓名、手机号"
          clearable
          style="width: 240px"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目">
        <choose-estate @change="onEstateChange" style="width: 240px;"></choose-estate>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" round @click="onSearch" icon="search"
          >查询</el-button
        >

        <el-tooltip
          class="box-item"
          effect="dark"
          content="下载查询结果数据"
          placement="top"
        >
          <el-button
            icon="Download"
            v-power="'admin/v1/reportAnalysis/con/stat/export_excel'"
            @click="downloadExcel"
            :loading="downloading"
            >下载数据</el-button
          >
        </el-tooltip>
      </el-form-item>
    </el-form>
    <div></div>
  </el-card>
  <el-card class="box data" v-loading="loading">
    <el-table :data="tableData.data" border stripe>
      <el-table-column
        label="公司名称"
        prop="companyName"
        min-width="300"
      ></el-table-column>
      <el-table-column
        label="项目"
        prop="estateName"
       width="300"
      ></el-table-column>
      <el-table-column
        label="报备人"
        prop="consumerName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="报备人手机"
        prop="consumerMobile"
        width="120"
      ></el-table-column>
      <el-table-column
        label="带看人"
        prop="daikanName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="带看人手机"
        prop="daikanMobile"
        width="120"
      ></el-table-column>
      <el-table-column
        label="报备日期"
        prop="createDate"
        width="160"
      ></el-table-column>
      <el-table-column
        label="报备总数"
        prop="totalCounts"
        width="140"
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageCurrentChange"
      :current-page="query.pageIndex"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="tableData.counts"
    ></el-pagination>
  </el-card>
</template>

<script>
import fileDownload from "js-file-download";
import ChooseEstate from "../../component/choose_estate.vue";
export default {
  components: {
    ChooseEstate,
  },
  data() {
    return {
      loading: false,
      downloading: false,
      query: {
        pageIndex: 1,
        pageSize: 20,
        sort: {
          order: "",
          prop: "",
        },
        q: "",
      },
      tableData: {
        counts: 0,
      },
    };
  },
  created() {
    this.query.dates = [
      this.$moment().add(-1, "months").format("YYYY-MM-DD"),
      this.$moment().format("YYYY-MM-DD"),
    ];

    this.loadData();
  },
  methods: {
    /**
     * 搜索
     */
    onSearch() {
      this.query.pageIndex = 1;
      this.loadData();
    },
    /**
     * 分页页数更改
     */
    pageSizeChange(val) {
      this.query.pageSize = val;
      this.loadData();
    },

    /**
     * 分页页码更改
     */
    pageCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },

    /**
     * 项目选择
     */
    onEstateChange(id) {
      if (id) {
        this.query.estateId = id;
      } else {
        delete this.query.estateId;
      }
    },

    /**
     *
     */
    loadData() {
      this.loading = true;
      this.$http
        .post("/admin/v1/reportAnalysis/con/stat", this.query)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data;
          }
        })
        .finally(() => (this.loading = false));
    },
    /**
     * 下载数据
     */
    downloadExcel() {
      this.downloading = true;
      var arg = Object.assign({}, this.query);
      delete arg.storeIds;
      if (
        Array.isArray(this.query.storeIds) &&
        this.query.storeIds.length > 0
      ) {
        arg.store_ids = this.query.storeIds.map((x) => {
          return x[1];
        });
      }
      this.$http
        .post("admin/v1/reportAnalysis/con/stat/export_excel", arg, {
          responseType: "blob",
        })
        .then((res) => {
          fileDownload(res, "人员报备统计.xlsx");
        })
        .finally(() => {
          this.downloading = false;
        });
    },
  },
};
</script>

<style scoped></style>
